import { Component, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AudanetWindowSyncService } from 'src/app/feature-module/audanet-integration/service/audanet-window-sync.service';
import { MediaService } from 'src/app/shared/services/media.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { CostEstimation, CostEstimationFormBuilder } from 'src/app/feature-module/cost-estimations/models/CostEstimation';
import { CostEstimationService } from 'src/app/feature-module/cost-estimations/service/cost-estimation.service';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { DocumentType } from 'src/app/shared/model/DocumentType';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { FileInfo } from '@progress/kendo-angular-upload';
import { CostEstimationType } from '../../models/CostEstimationType';
import { DocumentKind } from 'src/app/shared/model/DocumentKind';
import { tap } from 'rxjs';
import { CurrentClaimDataService } from 'src/app/feature-module/claims-data/service/current-claim-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-cost-estimation',
  templateUrl: './manage-cost-estimation.component.html',
  styleUrls: ['./manage-cost-estimation.component.scss']
})
export class ManageCostEstimationComponent extends DialogContentBase implements OnInit {

  constructor(@Optional() public dialog: DialogRef,
    private fb: UntypedFormBuilder,
    private costEstimationService: CostEstimationService,
    private documentService: DocumentService,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService,
    private mediaService: MediaService,
    private currentClaimDataService : CurrentClaimDataService,
    private activatedRoute: ActivatedRoute,
    private windowSync: AudanetWindowSyncService) {
    super(dialog);
  }

  estimationForm: UntypedFormGroup;
  estimation: CostEstimation;
  filesToAttachOnInit: FileInfo[] = [];
  acceptingValuesFromAudanet = false;
  
  editMode: boolean;
  isProcessing: boolean;

  standardCostEstimationType = CostEstimationType.Standard;
  additionalCostEstimationType = CostEstimationType.Additional;

  ngOnInit(): void {
    if (this.dialog) {
      this.initForm();
      return;
    }

    // opened in a separate window (routed), not as a dialog
    const id = Number(this.activatedRoute.snapshot.paramMap.get('costEstimationId'));
    this.costEstimationService.getCostEstimation(id).subscribe((r) => {
      this.estimation = r;
      this.initForm();
    });
  }

  initForm(): void {

    this.editMode = (this.estimation.id > 0)
    this.estimationForm = CostEstimationFormBuilder.getForm(this.fb, this.estimation);

    if(this.filesToAttachOnInit){
      this.estimationForm.controls['filesToAttach'].setValue(this.filesToAttachOnInit);
    }
  }

  cancel() {
    if (this.dialog) {
      this.dialog.close({ text: 'Cancel' });
    } else {
      window.close();
    }
  }

  confirm() {

    let documentKindId = DocumentKind.CostEstimation;

    if(this.acceptingValuesFromAudanet){
      documentKindId = DocumentKind.CostEstimationAccepted;
      if(this.estimation.acceptedAmount != this.estimation.netAmount){
        documentKindId = DocumentKind.CostEstimationPartiallyAccepted;
      }
    }

    if(this.estimation.costEstimationTypeId == CostEstimationType.Additional){
      
      documentKindId = DocumentKind.AdditionalCostEstimation;
      if(this.acceptingValuesFromAudanet){
        documentKindId = DocumentKind.AdditionalCostEstimationAccepted;
        if(this.estimation.acceptedAmount != this.estimation.netAmount){
          documentKindId = DocumentKind.AdditionalCostEstimationPartiallyAccepted;
        }
      }
    }

    if (!this.formUtilsService.markFormGroupTouched(this.estimationForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.estimation, this.estimationForm.value);

    const filesToAttach = this.estimationForm.controls['filesToAttach'].value;
    this.isProcessing = true

    this.costEstimationService.storeCostEstimation(this.estimation)
    .pipe(tap(() => this.isProcessing = false))
    .subscribe({
      next: (r) => {
        this.isProcessing = false;
        
        this.documentService.uploadAttachedDocuments(filesToAttach, 
          DocumentType.CostEstimation,
          r.toString(),
          ReferenceType.CostEstimation,
           this.estimation.claimIdentifier,
           documentKindId
           );

        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.currentClaimDataService.RefreshCurrentClaim(this.estimation.claimIdentifier);
        if (this.dialog) {
          this.dialog.close({ text: 'OK', id: r.toString(), type: this.estimation.costEstimationTypeId });
        } else {
          this.windowSync.notifyCostEstimationChanged({
            claimIdentifier: this.estimation.claimIdentifier,
            costEstimationId: this.estimation.id
          });
          window.close();
        }
      },
      error: () => this.isProcessing = false
    });
  }

  showInExternalWindow(estimationId: string) {
    const width = this.mediaService.getFullHdRelativeWidth(0.9);
    const height = this.mediaService.getFullHdRelativeHeight(0.9);

 let webAppPath = '';
    if(environment.wepAppName){
      webAppPath = "/" + environment.wepAppName;
    }

    const documentLink = window.location.origin + webAppPath + `/claimsCenter/costEstimation/${estimationId}`;


    window.open(documentLink, '_blank', `width=${width},height=${height}`);
  }
}


